import React from 'react'
import { SubmitButton } from '../generic/submit-button'
import { ModePaiement } from '../../model/entities/mode-paiement'
import {  InvestResponse } from '../../model/dto/response'
import { AttentePaiementPane } from './attente-paiement-pane'
import { Icon } from 'semantic-ui-react'

type Props = {
    montant?: string,
    projetId?: number,
    montantAVirer?:string,
    hasUserInvestimentsByVirementEnCours: boolean;
    showAttentePaiement?: boolean;
    isDon?: boolean,
    onSubmitImpossible?: (message: string) => void;
    onClickAttentePaiement?: () => void;
    onVirementSuccess?: (response: InvestResponse) => void;
}

const bankLogo = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="SVG namespace ">
<path d="M11.5 1L2 6V8H21V6M16 10V17H19V10M2 22H21V19H2M10 10V17H13V10M4 10V17H7V10H4Z" fill="#005578"/>
</svg>

const transfertLogo = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="SVG namespace ">
<path d="M21 9L17 5V8H10V10H17V13M7 11L3 15L7 19V16H14V14H7V11Z" fill="#005578"/>
</svg>

export function VirementClassiquePane({
    montant, 
    projetId, 
    montantAVirer, 
    showAttentePaiement, 
    hasUserInvestimentsByVirementEnCours, 
    isDon,
    onSubmitImpossible, 
    onClickAttentePaiement, 
    onVirementSuccess
}: Props) {

    return (
        <div>
            {showAttentePaiement ? ( 
                <AttentePaiementPane 
                    montant={montant}
                    projetId={projetId}
                    modePaiement={ModePaiement.VIREMENT_CLASSIQUE}
                    onSubmitImpossible={onSubmitImpossible}
                    onInvestSuccess={onVirementSuccess}
                    isDon= {isDon}
                />
            ) 
            : 
            (
            <div style={{display:'flex', flexDirection:'column'}}>
                <p css={{fontWeight: 'bold', fontSize: '16px', marginBottom: '10px'}}>Virement classique</p>
                {hasUserInvestimentsByVirementEnCours ? (
                    <div style={{marginTop:10, display:'flex', justifyContent:'space-between'}}>
                        <div style={{marginRight:10}}>
                        <Icon name='info circle' size='big' color="blue"/>
                        </div>
                        <div style={{display:'flex', flexDirection:'column'}}>
                            <p >Vous avez déjà un investissement par virement en cours pour lequel vous avez reçu les informations nécessaires à sa réalisation par email.</p>
                            <p>À la réception de ce dernier vous pourrez de nouveau investir par virement, en attendant vous pouvez réaliser ce paiement par carte bancaire.</p>
                        </div>
                    </div>
                ) : (
                <>
                    <p css={{fontSize: '14px'}}>Afin d'effectuer un investissement via virement classique vous devez :</p>
                    <div css={{display : 'flex', marginTop:'15px', alignItems:'center'}}>
                        <span style={{marginRight:'10px'}}>{bankLogo} </span>
                        <p>Enregistrer auprès de votre banque l'IBAN de notre prestataire de paiement que nous allons vous transmettre</p>
                    </div>
                    <div css={{display : 'flex', marginTop:'15px', alignItems:'center'}}>
                        <span style={{marginRight:'10px'}}>{transfertLogo}</span>
                        <p >Effectuer votre virement pour un montant de {montantAVirer} € vers cet IBAN</p>
                    </div>
                    <div css={{marginTop:'15px', alignSelf:'end'}}>
                        <SubmitButton 
                            label={isDon ? "Confirmer ma demande de don": "Confirmer ma demande d'investissement"}
                            name="paymentButton"
                            onClick={onClickAttentePaiement}
                        />
                    </div>
                </>
                )}
                
            </div>
            )}
        </div>
    )
}